import React, { useEffect, useRef, useState } from 'react';
import { Dropdown } from 'primereact/dropdown';
import { Message } from 'primereact/message';
import { useSelector, useDispatch } from 'react-redux';
import { convertReq, convertName } from '../../utils/utils';
import { updateWebServiceReq, setWebservicesReq } from '../../../../store/modules/zenomSlice';

import { InputText } from 'primereact/inputtext';
import { getAllWebServicesByModuleId } from '../../../../service/request/moduleRequest';
import { setSelectedModule } from '../../../../store/modules/moduleSlice';

import { Button } from 'primereact/button';
import { portalDefterCheck } from '../../datasoft/utils/DatasoftRequest';
import { Toast } from 'primereact/toast';

export default function WebServicesReq({ req = null, title = null }) {
    const { selectedModule, updatedModule } = useSelector((state) => state.modules);
    const { webServiceReq } = useSelector((state) => state.zenom);

    const [webServicesList, setWebServicesList] = useState([]);
    const [loading, setLoading] = useState(true);
    const [selectedWebService, setSelectedWebService] = useState(null);

    const toast = useRef(null);

    const dispatch = useDispatch();

    const getWebServices = async () => {
        const res = await getAllWebServicesByModuleId(updatedModule?.id);
        setWebServicesList(res.data.data.filter((item) => item.visible === true));
        setLoading(false);
    };

    useEffect(() => {
        if (updatedModule && webServicesList.length === 0) {
            getWebServices();
        }
    }, [dispatch, updatedModule]);

    useEffect(() => {
        if (req && !selectedWebService) {
            dispatch(setWebservicesReq(req));
            dispatch(setSelectedModule(updatedModule.setting.settings.webService));
        }
    }, [dispatch, req, selectedWebService]);

    const onServiceInputChange = (e, title) => {
        dispatch(updateWebServiceReq({ title, value: e.target.value }));
    };

    const onInputChange = (value) => {
        setSelectedWebService(value);
        let copy = webServicesList.find((ws) => ws.id === value);
        dispatch(setSelectedModule(copy));
        dispatch(setWebservicesReq(convertReq(copy.requirements.split(','))));
    };

    const handleCheckPortal = async () => {
        let copyTitle = selectedWebService ? selectedModule.title : title;
        const webService = webServicesList.find((item) => item.title === copyTitle);
        const data = {
            url: webService.url,
            username: webServiceReq.username,
            password: webServiceReq.password
        };

        const res = await portalDefterCheck(data);

        if (res.data.success) {
            toast.current.show({ severity: 'success', summary: 'Başarılı', detail: 'Web servis kullanıcı bilgileriniz doğrudur', life: 3000 });
        } else {
            toast.current.show({ severity: 'error', summary: 'Hata', detail: 'Web servis kullanıcı bilgileriniz hatalıdır', life: 3000 });
        }
    };

    return (
        <div className="w-full">
            <Toast ref={toast} />
            <div>
                <Message severity="warn" className="block mb-3 " text="Web Servis Programını değiştirmek için buradan farklı bir seçim yapınız." />
                <Dropdown
                    emptyFilterMessage="Program bulunamadı"
                    emptyMessage="Program bulunamadı"
                    id="Program Listesi"
                    filter
                    value={selectedWebService}
                    options={webServicesList.map((program) => ({ label: program.title, value: program.id })) || []}
                    onChange={(e) => onInputChange(e.value)}
                    placeholder="Program Listesi"
                    className="w-full"
                />
            </div>
            <div className="mt-5">
                <h3>{selectedWebService ? selectedModule.title : title}</h3>
                {webServiceReq &&
                    Object.keys(webServiceReq)?.map((req, i) => {
                        return (
                            <div key={i} className="py-3">
                                <div className="w-full mb-2">
                                    <label htmlFor={req}>{convertName(req)}</label>
                                </div>
                                <div className="w-full">
                                    <InputText onChange={(e) => onServiceInputChange(e, req)} placeholder={convertName(req)} value={webServiceReq[req]} type="text" className="w-full" />
                                </div>
                            </div>
                        );
                    })}
                <Button label="Şifreyi Kontrol Et" className="flex-shrink-0" onClick={handleCheckPortal} />
            </div>
        </div>
    );
}
